import { useContext, useEffect, useState } from "react"
import { Card, Col, Row } from "react-bootstrap"
import { FaPen } from "react-icons/fa"
import { Link } from "react-router-dom"
import Get from "../../api/Get"
import { ROLE_LIST } from "../../api/Routes"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"
import TableSearch from "../../components/TableSearch"
import { authContext } from "../../context/AuthContext"
import LoadingList from "../../loader/LoadingList"

function ListRole({url}){
    const [loading, setLoading] = useState(true)
    const {auth} = useContext(authContext)
    const [items, setItems] = useState([])

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        setLoading(true)
        let mounted = true;
        Get({url: ROLE_LIST, access_token: auth.data.access_token})
        .then(response=>{
            if(mounted){
                console.log(response)
                setItems(response.data.data.response)
                setLoading(false)
            }
            
        })
        .catch(error=>{
            setLoading(false)
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })

        return () => mounted = false
    }, [])

    const actions = (cell, row, index) => {        
        return (
            <div>
                <ul className="list-inline mb-0">
                    <li className="list-inline-item"><Link to={`${url}/${row.id}`}><FaPen className='iconAction colorNaranja' /></Link></li>
                </ul>          
            </div>
        );
    }

    const formatAccount = cell =>{
        return cell.map((item)=><span key={item.id} className="badge badge-secondary mr-1">{item.name}</span>)
    }

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, 
        {
            dataField: 'name',
            text: 'NOMBRE',
            headerStyle: { width: '35%' },
        },
        {
            dataField: 'accounts',
            text: 'Cuenta',
            formatter: formatAccount
        },
        {
            dataField: '',
            isDummyField: true,
            text: 'ACCIONES',
            style:{
                textAlign: 'center'
            },
            headerStyle: { width: '10%', textAlign: 'center' },
            formatter: actions,            
        }
    ]

    return (
        <>
            {loading && <LoadingList />}
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">Roles</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-1 mt-3">
                        <Card.Body>                            
                            <TableSearch columns={columns} items={items}/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
    )
}

export default ListRole